import Api from './Api';

const END_POINT = 'units';

export default {
    async get_all(filters = null) {        
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request)
    },
    async store(unit) {
        return await Api.post(`${END_POINT}`, unit)
    },
    async update(unit) {
        return await Api.patch(`${END_POINT}/${unit.id}`, unit)
    },
    async change_status(unit) {
        return await Api.patch(`${END_POINT}/${unit.id}/change-status`, unit)
    },
    async delete(unit) {
        return await Api.delete(`${END_POINT}/${unit.id}`, unit)
    }
}